import { Button } from "@/components/ui/button";
import { CheckCircle2, PhoneCall } from "lucide-react";
import { usePhoneBar } from "@/contexts/PhoneBarContext";
import roofingProject from "@/assets/roofing-project-1.jpg";

const benefits = [
  "0% interest financing options available",
  "As low as $99/month on qualifying roofs",
  "No money down — start your project today",
  "We work with all major insurance carriers",
  "Free roof inspection & detailed estimate",
];

export const AdsFinancingSection = () => {
  const { phoneNumber } = usePhoneBar();
  const formattedPhone = phoneNumber.replace("+1", "").replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");

  return (
    <section className="py-16 bg-background">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-extrabold text-foreground mb-2">
              Affordable Roofing,{" "}
              <span className="text-primary">No Surprises</span>
            </h2>
            <p className="text-muted-foreground mb-6">
              We believe every Long Island homeowner deserves a safe, beautiful roof — regardless of budget. That's why we offer flexible financing with transparent pricing.
            </p>
            <ul className="space-y-3 mb-8">
              {benefits.map((b) => (
                <li key={b} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-primary mt-0.5 shrink-0" />
                  <span className="text-foreground">{b}</span>
                </li>
              ))}
            </ul>
            <Button size="lg" className="font-bold" onClick={() => (window.location.href = `tel:${phoneNumber}`)}>
              <PhoneCall className="w-4 h-4 mr-2" />
              Call {formattedPhone}
            </Button>
          </div>
          <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-[4/3]">
            <img src={roofingProject} alt="Completed roofing project" className="w-full h-full object-cover" />
            <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/60 to-transparent p-6">
              <p className="text-white font-bold text-lg">Recent Project — Babylon, NY</p>
              <p className="text-white/80 text-sm">Full GAF Timberline HDZ replacement</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
